import useVisible from "../../hooks/useVisible.jsx";
import handleClick from "../../utils/handleClick.js";

function TransitionsDropZone({ selectedTag, buttonTags, generateButtonTags }) {
  const [isVisible, setIsVisible] = useVisible("TransitionDropZoneVisibility");

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-regular fa-images"></i>
          <div />
        </div>
        <div className="button-card__title">Transitions Drop Zone</div>
        {generateButtonTags()}
      </li>
      <div className={`resolution-tools ${isVisible ? "" : "hidden"}`}>
        <div
          onClick={() =>
            handleClick("transitionDropZoneMotion", {
              type: "comp",
              notification: true,
            })
          }
          className="resolution-tools__button"
        >
          <i class="fa-solid fa-image-polaroid"></i>
          <span>Active Comp</span>
        </div>
        <div
          onClick={() =>
            handleClick("transitionDropZoneMotion", {
              type: "selected comp",
              notification: true,
            })
          }
          className="resolution-tools__button"
        >
          <i class="fa-solid fa-images"></i>
          <span>Selected Comps</span>
        </div>
        <div
          onClick={() => handleClick("ae2RenameAB")}
          className="resolution-tools__button"
        >
          <i class="fa-light fa-input-text"></i>
          <span>Rename A-B</span>
        </div>
      </div>
    </>
  );
}

export default TransitionsDropZone;
